export const firebaseProductionConfig = {
  apiKey: "AIzaSyD-yAj0QvZWrJXb6WdfhQgNWdBq4JoKrBs",
  authDomain: "deardoc-appointment-manager.firebaseapp.com",
  projectId: "deardoc-appointment-manager",
  storageBucket: "deardoc-appointment-manager.appspot.com",
  messagingSenderId: "1054408912616",
  appId: "1:1054408912616:web:5f4ad4a25275efa62aa35d",
  measurementId: "G-2R2JXB5G0P",
};
